import {
  TIMELINE_FILTER_ADD,
  TIMELINE_FILTER_CLEAR,
  AUTOMATION_LOGS_FILTER_ADD,
  AUTOMATION_LOGS_FILTER_CLEAR,
  SET_CURRENT_SELECTED_BUILD,
  SET_CURRENT_SELECTED_TEST,
  SET_CURRENT_SELECTED_TEST_LIST,
  RESET_CURRENT_SELECTED_TEST,
  SWITCH_DRAWER_STATE,
  SWITCH_FILTER_FLAKY_TESTS,
  SWITCH_BROWSE_OR_FLAKY_TEST_DRAWER,
  TEST_TIMELINE_FILTER_ADD,
  TEST_TIMELINE_FILTER_CLEAR,
  SET_TEST_SIDEBAR
} from "../../actionTypeConstants/ml2.0/FilterPersist";

const initialState = {
  timeline: {
    status: [],
    project: [],
    username: [],
    buildType: [],
    tag: [],
    testTag: [],
    build: [],
    searchText: "",
    range: "",
    sortBy: "",
    sortType: "",
    filterBy: ""
  },
  testTimeline: {
    os: [],
    status: [],
    project: [],
    browser: [],
    buildName: [],
    build: [],
    username: [],
    type: [],
    tag: [],
    searchText: "",
    range: "",
    filterBy: "",
    sortBy: "",
    sortType: "",
    resolution: []
  },
  automationLogs: {
    build: [],
    status: [],
    username: [],
    tag: [],
    os: [],
    browser: [],
    searchText: "",
    range: "",
    sortBy: "",
    sortType: "",
    autoHeal: false,
    user: []
  },
  analytics: {
    filter_string: null,
    previous_view: null
  },
  prev_page: {
    tab: null,
    view: null,
    page: null
  },
  currentSelectedBuild: {
    build: null
  },
  currentSelectedTest: {
    testId: null
  },
  currentSelectedTestIdList: {
    testIds: []
  },
  isDrawerOpen: false, // live interaction drawer
  isBrowseOrFlakyTestDrawerOpen: "", // normal browse tests drawer
  areFlakyTestsFiltered: false,
  isTestSideBarOpen: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case TIMELINE_FILTER_ADD:
      return {
        ...state,
        timeline: {
          ...state.timeline,
          ...action.result
        }
      };
    case TIMELINE_FILTER_CLEAR:
      return {
        ...state,
        timeline: {
          ...state.timeline,
          ...initialState.timeline
        }
      };
    case AUTOMATION_LOGS_FILTER_ADD:
      return {
        ...state,
        automationLogs: {
          ...state.automationLogs,
          ...action.result
        }
      };
    case AUTOMATION_LOGS_FILTER_CLEAR:
      return {
        ...state,
        automationLogs: {
          ...state.automationLogs,
          ...initialState.automationLogs
        }
      };

    case SET_CURRENT_SELECTED_BUILD:
      return {
        ...state,
        currentSelectedBuild: {
          ...state.currentSelectedBuild,
          ...action.result
        }
      };
    case SET_CURRENT_SELECTED_TEST:
      return {
        ...state,
        currentSelectedTest: {
          ...state.currentSelectedTest,
          ...action.result
        }
      };
    case SET_CURRENT_SELECTED_TEST_LIST:
      return {
        ...state,
        currentSelectedTestIdList: {
          ...state.currentSelectedTestIdList,
          testIds: action.result
        }
      };
    case RESET_CURRENT_SELECTED_TEST:
      return {
        ...state,
        currentSelectedTest: {
          ...state.currentSelectedTest,
          ...initialState.currentSelectedTest
        }
      };
    case SWITCH_DRAWER_STATE:
      return {
        ...state,
        isDrawerOpen:
          action.result !== undefined ? action.result : !state.isDrawerOpen
      };

    case SWITCH_BROWSE_OR_FLAKY_TEST_DRAWER: {
      return {
        ...state,
        isBrowseOrFlakyTestDrawerOpen: action.result
      };
    }

    case SWITCH_FILTER_FLAKY_TESTS: {
      return {
        ...state,
        areFlakyTestsFiltered: action.result || !state.areFlakyTestsFiltered
      };
    }

    case TEST_TIMELINE_FILTER_ADD: {
      return {
        ...state,
        testTimeline: {
          ...state.testTimeline,
          ...action.result
        }
      };
    }

    case TEST_TIMELINE_FILTER_CLEAR: {
      return {
        ...state,
        testTimeline: {
          ...state.testTimeline,
          ...initialState.testTimeline
        }
      };
    }

    case SET_TEST_SIDEBAR: {
      return {
        ...state,
        isTestSideBarOpen: action.result
      };
    }

    default:
      return state;
  }
}
